import { truncate } from "fs";
import { LEFT_NAVIGATION_PAGE_URL } from "./navigation.models";
import { PAGE_CONFIG } from "./navigation.models";
import { IVoteItemsFields } from "../../common.interface";
import { COMMITTEE_LEVELS, DraftActionId, PAGE_ID, VOTE_TYPE_DESCRIPTION, VOTE_TYPE_ID, WI_TYPE } from "../../common.enum";

const { USER_PRIVILEGE } = PAGE_CONFIG;

export const DATE_RANGE_TYPE = {
  closeDate: "1",
};

export const API_PARAM_NULL_VALUE = " ";

export const ItemsPerPage = [
  { key: "1", text: "10", value: "10" },
  { key: "2", text: "25", value: "25" },
  { key: "3", text: "50", value: "50" },
  { key: "4", text: "75", value: "75" },
  { key: "5", text: "100", value: "100" },
];

export const CountryCodes = {
  UNITEDSTATES: { Code: "US", Name: "United States" },
  CANADA: { Code: "CA", Name: "Canada" },
};
// TODO : get domain prefix to set cookies doamin wise.
export const getDoaminPrefix = () => {
  const hostname = window.location.hostname;
  let prefixName = "";
  if (hostname) {
    let envPrefix = hostname.indexOf("-") > -1 ? hostname.split("-") : "";
    if (envPrefix && envPrefix.length > 0) {
      prefixName = `${envPrefix[0].toUpperCase()}`;
      if (prefixName == "QA") {
        prefixName = "TEST";
      }
      if (["DEV", "TEST", "STAGE"].includes(prefixName)) {
        prefixName = prefixName + "-";
      }
    }
  }
  return prefixName;
};

export const cookieKeysEnum = {
  APP_SESSIONID: `${getDoaminPrefix()}MCS-AZURE-APP-SESSION-ID`,
  accessToken: `${getDoaminPrefix()}MCS-AZURE-ACESS-TOKEN`,
  oktaToken: `${getDoaminPrefix()}MCS-OKTA-TOKEN`,
};

export const endDayTime = ' 23:59:59';
export const getSpecialCharacterValue = (characterString: string) => {
  let txt = document.createElement("textarea");
  txt.innerHTML = characterString;
  return txt.value;
};

export const convertCharacterEntityToHtml = (stringValue: string) => {
  const listOfCharacterEntity = ["&lt;", "&gt;", "&amp;", "&quot;", "&apos;", "&cent;", "&pound;", "&yen;", "&euro;", "&copy;", "&reg;"];
  for (const item of listOfCharacterEntity) {
    if (stringValue.includes(item)) {
      const getSpecialValue = getSpecialCharacterValue(item);
      const newStringValue = stringValue.replace(item, getSpecialValue);
      return newStringValue;
    }
  }
  return stringValue;
};
export const TypeIdForDocuments = {
  dashboard: 0,
  ballots: 1,
  ballotDetails: 2,
  workItem:2,
  draft:3,
  draftHistory:4,
  exportWorkItem:3,
  exportVoterSummary:0,
  exportBallotQueue: 5
};
export const TypeIdForTable = {
  draft:0,
  ballotHistory:1
};

export type ExtraField = {
  Key: string;
  Value: any;
};

export const getDocumentTypeId = () => {
  let docCategoryId = 0;
  const urlPathName = window.location.pathname; 
  if(urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS) === 0){
    docCategoryId = 5
  } else {
    switch (urlPathName) {
      case LEFT_NAVIGATION_PAGE_URL.BALLOTS:
        docCategoryId = 1;
        break;
      case LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS:
        docCategoryId = 2;
        break;
      case LEFT_NAVIGATION_PAGE_URL.WORKITEM:
        docCategoryId = 3;
        break;
      case LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG:
        docCategoryId = 4;  
        break;
      case LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE:
        docCategoryId = 5; 
        break;
    }
  }

  return docCategoryId;
};

export const getPageId = (hasDecrpytKey = false) => {
  let pageId = 0;
  const {pathname} = window.location;
  const urlPathName = `/${pathname.replace(/\//g, "")}`;
  if (!hasDecrpytKey) {
    switch (urlPathName) {
    case LEFT_NAVIGATION_PAGE_URL.BALLOTS:
      pageId = 8;
      break;
    case LEFT_NAVIGATION_PAGE_URL.WORKITEM:
      pageId = 7;
       break;
    }
  }
  else {
    if (urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL) === 0) {
      pageId = 3;
    }
    else if(urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS) === 0) {
      pageId = 9;
    }
    else if(urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS) === 0){
      pageId = 10;
    }
    else if(urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT) === 0){
      pageId = PAGE_ID.BALLOT_ITEM_DETAIL_RESULT;
    }
    else if(urlPathName.indexOf(LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE) === 0){
      pageId = PAGE_ID.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE;
    }
  }
  return pageId;
};

export const MANAGEDEPHOLDHEADER = [
  {
    title: "",
    hasSorting: false,
    className: "ballot-queue-checkbox",
    sortKey: "CheckboxAction",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: false,
    isDefaultSort: false,
  },
  {
    title: "Ballot Designation",
    hasSorting: false,
    className: "",
    sortKey: "BallotDesignation",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Item",
    hasSorting: false,
    className: "",
    sortKey: "ItemNumber",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Standard",
    hasSorting:false,
    className: "",
    sortKey: "StandardDesignationNumber",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Work Item",
    hasSorting: false,
    className: "",
    sortKey: "WorkItemNumber",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Action",
    hasSorting: false,
    className: "",
    sortKey: "BallotAction",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Item Description",
    hasSorting: false,
    className: "",
    sortKey: "ItemDescription",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  }, 
  {
    title: "WI Tracking No.",
    hasSorting: false,
    className: "",
    sortKey: "WITN",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Item Status",
    hasSorting:false,
    className: "",
    sortKey: "ItemStatus",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Dependency",
    hasSorting: false,
    className: "",
    sortKey: "Dependency",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "",
    hasSorting: false,
    className: "",
    sortKey: "Action",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: false,
    isDefaultSort: false,
  },
];

export const BALLOTSHEADERINFO = [
  {
    title: "Committee",
    colSN: 1,
    hasSorting: true,
    className: "",
    sortKey: "Committee",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Designation",
    colSN: 2,
    hasSorting: true,
    className: "",
    sortKey: "BallotDesignation",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Items",
    colSN: 3,
    hasSorting: true,
    className: "",
    sortKey: "ItemNo",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Status",
    colSN: 4,
    hasSorting: true,
    className: "",
    sortKey: "BallotStatus",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Type",
    colSN: 5,
    hasSorting: true,
    className: "",
    sortKey: "BallotType",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "% Return",
    colSN: 6,
    hasSorting: true,
    className: "",
    sortKey: "PercentageReturn",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    toolTipText:  "Lowest percentage return across all balloted committees",
    toolTipIcon: "fa-info-circle",
  },
  {
    title: "Publish Date",
    colSN: 7,
    hasSorting: true,
    className: "",
    sortKey: "PublishDate",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Close Date",
    colSN: 8,
    hasSorting: true,
    className: "",
    sortKey: "ClosingDate",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Modified Date",
    colSN: 9,
    hasSorting: true,
    className: "",
    sortKey: "ModifiedDate",
    orderBy: 0,
    orderByIcon: 0,
    isShow: false,
  },
  {
    title: "Administrative Assistant",
    colSN: 10,
    hasSorting: true,
    className: "",
    sortKey: "AdministrativeAssistant",
    orderBy: 0,
    orderByIcon: 0,
    isShow: false,
  },
  {
    title: "Staff Manager",
    colSN: 11,
    hasSorting: true,
    className: "",
    sortKey: "StaffManager",
    orderBy: 0,
    orderByIcon: 0,
    isShow: false,
  },
  {
    title: "Editor(s)",
    colSN: 12,
    hasSorting: true,
    className: "",
    sortKey: "Editor",
    orderBy: 0,
    orderByIcon: 0,
    isShow: false,
  },
];
export const DTNHEADERINFO = [
    {
        title: "DTN",
        hasSorting: true,
        className: "",
        sortKey: "DraftTrackingNumber",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "WI Tracking No.",
        hasSorting: true,
        className: "",
        sortKey: "WorkItemTrackingNumber",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Ballot",
        hasSorting: true,
        className: "",
        sortKey: "BallotNumber",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Ballot Action",
        hasSorting: true,
        className: "",
        sortKey: "DraftActionName",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Title",
        hasSorting: true,
        className: "",
        sortKey: "Title",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "DTN Status",
        hasSorting: true,
        className: "",
        sortKey: "DraftStatus",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Comment",
        hasSorting: true,
        className: "",
        sortKey: "DraftComment",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
]
export const DRAFTHEADERINFO = [
    {
        title: "WI Tracking No.",
        hasSorting: true,
        className: "",
        sortKey: "WorkItemTrackingNumber",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Ballot Action",
        hasSorting: true,
        className: "",
        sortKey: "DraftActionName",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Title",
        hasSorting: true,
        className: "",
        sortKey: "Title",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
        title: "Status",
        hasSorting: true,
        className: "",
        sortKey: "DraftStatus",
        orderBy: 0,
        sortType: 'alphanumeric',
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
    },
    {
      title: "Ballot",
      hasSorting: true,
      className: "",
      sortKey: "BallotNumber",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
]
export const BALLOTSUMMARYHEADERINFO = [
  {
    title: "",
    hasSorting: false,
    colSN: 1,
    className: "ballot-summary-checkbox",
    sortKey: "CheckboxAction",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
      title: "Item",
      hasSorting:true,
      colSN: 2,
      className: "ballot-summary-ItemNumber astm-table-td",
      sortKey: "ItemNumber",
      orderBy: 0,
      sortType: 'numeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
      title: "Subcommittee",
      hasSorting:true,
      colSN: 3,
      className: "",
      sortKey: "subCommittee",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
      title: "Standard",
      hasSorting:true,
      colSN: 4,
      className: "",
      sortKey: "FormattedStandardDesignation",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
      title: "Work Item",
      hasSorting:true,
      colSN: 5,
      className: "",
      sortKey: "WorkItemNumber",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
      title: "Ballot Action",
      hasSorting:true,
      colSN: 6,
      className: "",
      sortKey: "BallotAction",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
      title: "Item Description",
      hasSorting:true,
      colSN: 7,
      className: "",
      sortKey: "ItemDescription",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
    title: "WI Tracking No.",
    hasSorting:true,
    colSN: 8,
    className: "",
    sortKey: "WITN",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
      title: "Item Status",
      hasSorting:true,
      colSN: 9,
      className: "astm-table-td ballot-details-list-status",
      sortKey: "ItemStatus",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
    title: "Affirm with comment",
    hasSorting:false,
    colSN: 10,
    className: "",
    sortKey: "AffirmWithComment",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: false,
    isDefaultSort: false,
  },
  {
      title: "Total Affirm",
      hasSorting: false,
      colSN: 11,
      className: "",
      sortKey: "TotalAffirm",
      orderBy: 0,
      sortType: 'numeric',
      orderByIcon: 0,
      isShow: false,
      isDefaultSort: false,
  },
  {
      title: "Total Negative",
      hasSorting: false,
      colSN: 12,
      className: "",
      sortKey: "TotalNegative",
      orderBy: 0,
      sortType: 'numeric',
      orderByIcon: 0,
      isShow: false,
      isDefaultSort: false,
  },
  {
      title: "Abstain with comment",
      hasSorting: false,
      colSN: 13,
      className: "",
      sortKey: "AbstainWithComment",
      orderBy: 0,
      sortType: 'numeric',
      orderByIcon: 0,
      isShow: false,
      isDefaultSort: false,
  },
  {
      title: "Total Abstained",
      hasSorting: false,
      colSN: 14,
      className: "",
      sortKey: "TotalAbstained",
      orderBy: 0,
      sortType: 'numeric',
      orderByIcon: 0,
      isShow: false,
      isDefaultSort: false,
  },
  {
      title: "% Affirmative",
      hasSorting: false,
      colSN: 15,
      className: "",
      sortKey: "PercentageAffirmative",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: false,
      isDefaultSort: false,
  },  
  {
      title: "Documents",
      hasSorting: false,
      colSN: 16,
      className: "",
      sortKey: "Document",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
    title: "Action",
    hasSorting: false,
    colSN: 17,
    className: "",
    sortKey: "action",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
},
]

export const SNBALLOTSUMMARYHEADERINFO = [
  {
    title: "Main Ballot",
    hasSorting: true,
    colSN: 1,
    className: "astm-table-td ",
    sortKey: "MainBallot",
    orderBy: 2,
    sortType: "alphanumeric",
    orderByIcon: -1,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item",
    hasSorting: true,
    colSN: 2,
    className: "astm-table-td sn-ballot-item-details-col",
    sortKey: "ItemNumber",
    orderBy: 0,
    sortType: "numeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Standard",
    hasSorting: true,
    colSN: 3,
    className: "astm-table-td ",
    sortKey: "FormattedStandardDesignation", 
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Ballot Action",
    hasSorting: true,
    colSN: 4,
    className: "astm-table-td ",
    sortKey: "BallotAction",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "WI Tracking No.",
    hasSorting: true,
    colSN: 5,
    className: "astm-table-td ",
    sortKey: "WITN",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Status",
    hasSorting: true,
    colSN: 6,
   className: "astm-table-td ",
    sortKey: "ItemStatus",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Ballot Item Details",
    hasSorting: false,
    colSN: 7,
    className: "astm-table-td ballot-item-details-col",
    sortKey: "BallotItemDetail", 
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
];

export const BALLOTRECAPHEADERINFO =[{
    title: "Committee",
    hasSorting: true,
    className: "",
    sortKey: "Committee",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
},
{
    title: "Items",
    hasSorting: true,
    className: "",
    sortKey: "Items",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
},
{
    title: "Total Sent",
    hasSorting: true,
    className: "",
    sortKey: "TotalSent",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
},
{
    title: "Returned To Date",
    hasSorting: true,
    className: "",
    sortKey: "ReturnedToDate",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
},
{
    title: "Percent Returned",
    hasSorting: true,
    className: "",
    sortKey: "PercentReturned",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
},
{
    title: "Required For 60%",
    hasSorting: true,
    className: "",
    sortKey: "RequiredFor",
    orderBy: 0,
    sortType: 'numeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
},
]

export const WORKITEMSHEADERINFO = [
  {
    title: "Committee",
    hasSorting: true,
    colSN: 1,
    className: "",
    sortKey: "CommitteeDesignation",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Standard",
    hasSorting: true,
    colSN: 2,
    className: "",
    sortKey: "FormattedStandardDesignation",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Work Item",
    hasSorting: true,
    colSN: 3,
    className: "",
    sortKey: "WorkItemNumber",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "WI Type",
    hasSorting: true,
    colSN: 4,
    className: "",
    sortKey: "WorkItemTypeName",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Title",
    hasSorting: true,
    colSN: 5,
    className: "",
    sortKey: "Title",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "WI Status",
    hasSorting: true,
    colSN: 6,
    className: "",
    sortKey: "WorkItemStatus",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  }
];

export const ADDBALLOTHEADERINFO = [
  {
    title: "",
    hasSorting: false,
    className: "",
    sortKey: "CheckboxAction",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Committee",
    hasSorting: true,
    className: "",
    sortKey: "FormattedCommittee",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Concurrency",
    hasSorting: false,
    className: "",
    sortKey: "Concurrency",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: false,
    isDefaultSort: true,
  },
  {
    title: "Standard",
    hasSorting: true,
    className: "",
    sortKey: "FormattedStandardDesignation",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Work Item",
    hasSorting: true,
    className: "",
    sortKey: "WorkItemNumber",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "WI Tracking No.",
    hasSorting: true,
    className: "",
    sortKey: "WITN",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Action",
    hasSorting: true,
    className: "",
    sortKey: "QueueAction",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Level",
    hasSorting: true,
    className: "",
    sortKey: "BallotLevel",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Item Description",
    hasSorting: true,
    className: "",
    sortKey: "ItemDescription",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Modified Date",
    hasSorting: true,
    className: "",
    sortKey: "ModifiedDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Document",
    hasSorting: false,
    className: "",
    sortKey: "Document",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  }
];

export const SELECTALLADDBALLOTHEADERINFO = [
  {
    title: "",
    hasSorting: false,
    className: "ballot-queue-checkbox",
    sortKey: "CheckboxAction",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Committee",
    hasSorting: true,
    className: "",
    sortKey: "FormattedCommittee",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Concurrency",
    hasSorting: false,
    className: "",
    sortKey: "Concurrency",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: false,
    isDefaultSort: true,
  },
  {
    title: "Standard",
    hasSorting: true,
    className: "",
    sortKey: "FormattedStandardDesignation",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Work Item",
    hasSorting: true,
    className: "",
    sortKey: "WorkItemNumber",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "WI Tracking No.",
    hasSorting: true,
    className: "",
    sortKey: "WITN",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Action",
    hasSorting: true,
    className: "",
    sortKey: "QueueAction",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Ballot Level",
    hasSorting: true,
    className: "",
    sortKey: "BallotLevel",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Item Description",
    hasSorting: true,
    className: "",
    sortKey: "ItemDescription",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Modified Date",
    hasSorting: true,
    className: "",
    sortKey: "ModifiedDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  },
  {
    title: "Document",
    hasSorting: false,
    className: "",
    sortKey: "Document",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
  }
];

export const WORKITEM_AUDITLOG_TABLEHEADER = [
  { 'title': 'Modified Date/Time', 'hasSorting': true, 'className': "date astm-table-td pointer ", "sortKey": 'When', 'orderBy': 0, 'orderByIcon': 2,'widthClassName':"date-col",'width':"20%" },
  { 'title': 'Work Item Number', 'hasSorting': true, 'className': "designation astm-table-td pointer ", 'sortKey': 'Designation', 'orderBy': 0, 'orderByIcon': 0,'widthClassName':"designation-col","width":"18%" },
  { 'title': 'Description', 'hasSorting': false, 'className': "reason astm-table-td", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"reason-col","width":"36%"},
  { 'title': 'Modified By', 'hasSorting': true, 'className': "modifiedby astm-table-td pointer ", 'sortKey': 'Who', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"modifiedby-col","width":"22%"}
]
export const WITN_AUDITLOG_TABLEHEADER = [
  { 'title': 'Modified Date/Time', 'hasSorting': true, 'className': "date astm-table-td pointer ", "sortKey": 'When', 'orderBy': 0, 'orderByIcon': 2,'widthClassName':"date-col",'width':"16%" },
  { 'title': 'WI Tracking No.', 'hasSorting': true, 'className': "designation astm-table-td pointer ", 'sortKey': 'Designation', 'orderBy': 0, 'orderByIcon': 0,'widthClassName':"designation-col","width":"14%" },
  { 'title': 'Description', 'hasSorting': false, 'className': "reason astm-table-td", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"desc-col","width":"34%"},
  { 'title': 'Reason for Update', 'hasSorting': false, 'className': "reason astm-table-td", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"reason-col","width":"14%"},
  { 'title': 'Modified By', 'hasSorting': true, 'className': "modifiedby astm-table-td pointer ", 'sortKey': 'Who', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"modifiedby-col","width":"14%"}
]

export const BALLOT_AUDITLOG_TABLEHEADER = [
  { 'title': 'Modified Date/Time', 'hasSorting': true, 'className': "date astm-table-td pointer ", "sortKey": 'When', 'orderBy': 0, 'orderByIcon': 2,'widthClassName':"date-col",'width':"20%" },
  { 'title': 'Description', 'hasSorting': false, 'className': "reason astm-table-td", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"desc-col","width":"40%"},
  { 'title': 'Reason for Update', 'hasSorting': false, 'className': "reason astm-table-td", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"reason-col","width":"20%"},
  { 'title': 'Modified By', 'hasSorting': true, 'className': "modifiedby astm-table-td pointer ", 'sortKey': 'Who', 'orderBy': 0, 'orderByIcon': 0 ,'widthClassName':"modifiedby-col","width":"20%"}
]

export const DRAFTBALLOTHISTORY = [
  {
    title: "Original Ballot Item Number",
    hasSorting: true,
    className: "",
    sortKey: "ItemTrackNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Ballot (SN Review)",
    hasSorting: true,
    className: "ballot-sn-review",
    sortKey: "BallotNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Number",
    hasSorting: true,
    className: "",
    sortKey: "ItemNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Concurrent",
    hasSorting: true,
    className: "",
    sortKey: "Concurrent",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Description",
    hasSorting: true,
    className: "item-description",
    sortKey: "ItemDescription",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Status",
    hasSorting: true,
    className: "",
    sortKey: "Status",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Negative",
    hasSorting: true,
    className: "",
    sortKey: "Negative",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Resolved",
    hasSorting: true,
    className: "",
    sortKey: "ItemResolvedDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Approved",
    hasSorting: true,
    className: "",
    sortKey: "COSApprovalDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
];
export const BALLOTHISTORY = [
  {
    title: "WI Tracking No.",
    hasSorting: true,
    className: "",
    sortKey: "WorkItemTrackingNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Ballot (SN Review)",
    hasSorting: true,
    className: "",
    sortKey: "BallotNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Number",
    hasSorting: true,
    className: "",
    sortKey: "ItemNumber",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
      title: "Ballot Action",
      hasSorting: true,
      className: "",
      sortKey: "DraftActionName",
      orderBy: 0,
      sortType: 'alphanumeric',
      orderByIcon: 0,
      isShow: true,
      isDefaultSort: true,
  },
  {
    title: "Item Description",
    hasSorting: true,
    className: "",
    sortKey: "Paragraphs",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Item Status",
    hasSorting: true,
    className: "",
    sortKey: "BallotItemStatusLit",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Negative",
    hasSorting: true,
    className: "",
    sortKey: "Negative",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Resolved",
    hasSorting: true,
    className: "",
    sortKey: "ItemResolvedDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Approved",
    hasSorting: true,
    className: "",
    sortKey: "COSApprovalDate",
    sortType: 'alphanumeric',
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
];
export const MANAGEANSICOMMITTEEHEADERINFO = [
  {
    title: "ANSI Committee",
    hasSorting: true,
    className: "ansi-table  astm-table-td",
    sortKey: "MainCommittee",
    orderBy: 2,
    sortType: 'alphanumeric',
    orderByIcon: -1,
    isShow: true,
    isDefaultSort: true,
    style: { width: "17%" },
    dataType: "hyperlink"
  },
  {
    title: "ANSI Subcommittees/Sections ",
    hasSorting: false,
    className: "ansi-table  astm-table-td",
    sortKey: "subCommitteeList",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
    style: { width: "53%" },
    dataType: "array"
  },
  {
    title: "Modified Date",
    hasSorting: true,
    className: "ansi-table astm-table-td",
    sortKey: "ModifiedDate",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    style: { width: "17%" },
    dataType: "date"
  },
  {
    title: "Action",
    hasSorting: false,
    className: "ansi-table astm-table-td",
    sortKey: "WorkItemNumber",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    style: { width: "13%" },
    dataType: "icon"
  }
];

export const MANAGEANSISTANDARDHEADERINFO = [
  {
    title: "Jurisdiction",
    hasSorting: true,
    className: "ansi-table  astm-table-td",
    sortKey: "FormattedCommittee",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
    style: { width: "17%" },
    dataType: "hyperlink"
  },
  {
    title: "ANSI Standard",
    hasSorting: true,
    className: "ansi-table  astm-table-td",
    sortKey: "FormattedStandardDesignation",
    orderBy: 2,
    sortType: 'alphanumeric',
    orderByIcon: -1,
    isShow: true,
    isDefaultSort: true,
    style: { width: "17%" },
    dataType: "hyperlink"
  },
  {
    title: "ANSI Standard Title",
    hasSorting: false,
    className: "ansi-table  astm-table-td",
    sortKey: "Title",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
    style: { width: "36%" },
    dataType: "text"
  },
  {
    title: "Modified Date",
    hasSorting: true,
    className: "ansi-table astm-table-td",
    sortKey: "ModifiedDate",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    style: { width: "17%" },
    dataType: "date"
  },
  {
    title: "Action",
    hasSorting: false,
    className: "ansi-table astm-table-td",
    sortKey: "action",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    style: { width: "13%" },
    dataType: "icon"
  }
];
export const MANAGEBSR108HEADERINFO = [
    {
        title: "Date",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "Date",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
        style: { width: "15%" },
        dataType: "date",
    },
    {
        title: "File Name",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "FileName",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "25%" },
        dataType: "hyperlink",
    },
    {
        title: "Added By",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "AddedBy",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "15%" },
        dataType: "hyperlink",
    },
    {
        title: "Sent to PSA",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "SentPSA",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "18%" },
        dataType: "text",
    },
    {
        title: "PR Dates Added",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "PRDate",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "22%" },
        dataType: "date",
    },
    {
        title: "Action",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "action",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "5%" },
        dataType: "icon",
    },
];
export const MANAGEBSR109HEADERINFO = [
    {
        title: "Date",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "Date",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
        style: { width: "15%" },
        dataType: "date",
    },
    {
        title: "File Name",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "FileName",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "25%" },
        dataType: "hyperlink",
    },
    {
        title: "Added By",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "AddedBy",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "15%" },
        dataType: "hyperlink",
    },
    {
        title: "Sent to PSA",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "SentPSA",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "18%" },
        dataType: "text",
    },
    {
        title: "Action",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "action",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "5%" },
        dataType: "icon",
    },
];

export const ANSIAUDITLOGTABLEHEADER = [
  {
    title: "Modified Date/Time",
    hasSorting: true,
    className: "ansi-table  astm-table-td",
    sortKey: "When",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 2,
    isShow: true,
    isDefaultSort: true,
    style: { width: "20%" },
    dataType: "date"
  },
  {
    title: "Description",
    hasSorting: false,
    className: "ansi-table  astm-table-td",
    sortKey: "What",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
    style: { width: "40%" },
    dataType: "description"
  },
  {
    title: "Reason for Update",
    hasSorting: false,
    className: "ansi-table  astm-table-td",
    sortKey: "Why",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
    style: { width: "20%" },
    dataType: "text"
  },
  {
    title: "Modified By",
    hasSorting: true,
    className: "ansi-table astm-table-td",
    sortKey: "Who",
    orderBy: 0,
    sortType: 'alphanumeric',
    orderByIcon: 0,
    isShow: true,
    style: { width: "20%" },
    dataType: "hyperlink"
  }
];

export const MANAGEPINSREPORTSHEADERINFO = [
    {
        title: "Date",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "Date",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: true,
        style: { width: "15%" },
        dataType: "date",
    },
    {
        title: "File Name",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "FileName",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "25%" },
        dataType: "hyperlink",
    },
    {
        title: "Processing Status",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "ProcessingStatus",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "18%" },
        dataType: "text",
    },
    {
        title: "PR Dates Added",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "PRDate",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "22%" },
        dataType: "date",
    },
    {
        title: "Processed By",
        hasSorting: true,
        className: "ansi-table astm-table-td",
        sortKey: "ProcessedBy",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "15%" },
        dataType: "text",
    },
    {
        title: "Action",
        hasSorting: false,
        className: "ansi-table astm-table-td",
        sortKey: "action",
        orderBy: 0,
        sortType: "alphanumeric",
        orderByIcon: 0,
        isShow: true,
        isDefaultSort: false,
        style: { width: "5%" },
        dataType: "icon",
    },
];

export interface BallotListDataProps {
  ItemNumber?: string | number;
  BallotDesignation?: string;
  Committee?: string;
  ItemNo?: number;
  BallotStatus?: string;
  BallotType?: string;
  PercentageReturn?: any;
  ModifiedDate?: Date;
  PublishDate?: Date;
  ClosingDate?: Date;
  StaffManager?: string;
  AdministrativeAssistant?: any;
  Editor?: any;
  Items?: number; 
  TotalSent?: number;
  ReturnedToDate?: number;
  PercentReturned?: number;
  RequiredFor?: number;
  VoteItems?: IVoteItemsFields;
  VoterAccountNumber?: string;
  VoterFirstName?: string;
  VoterMiddleName?: string;
  VoterLastName?: string;
  VoteEnteredDate?: string;
  VoteDescription?: string;
  NegativeStatusId?: number;
  BallotNegativeId?: number;
  NegativeStatusDate?: string;
  MemIndFileFullS3Path?: string;
  FileName?: string;
  IsApproved?: boolean;
  DispositionApprovedDate?: string;
  VoteWeightTag?: string;
  AuditlogData?:any;
}

export interface DropdownItemsProps {
  HeaderId: string;
  HeaderName: string;
  FieldName: string,
  DisplayName: string,
  IsSelected: boolean;
  IsDefaultSelected: boolean;
  onItemChange: any;
}
[];

export interface GridPreferenceProps {
ApplicationGridColumnMasterId: number,
ApplicationGridMasterId: number,
FieldName: string,
DisplayName: string,
Sequence: number,
IsSelected: boolean,
IsMandatory: boolean,
IsExportable: boolean,
IsFixedWidth: boolean,
IsSortable: boolean,
IsEditable: boolean,
onItemChange: any;
}

export const allDocumentsDefaultState = {
  pageSize: 10,
  activePageNumber: 1,
  sortFilterInfo: { ModifiedDate: 2 },
};

export const getUrlFromCategoryId = (documentCategoryId: number) => {
  let documentURL = LEFT_NAVIGATION_PAGE_URL.BALLOTS;
  switch (documentCategoryId) {
    case TypeIdForDocuments.ballots:
      documentURL = `${process.env.REACT_APP_REDIRECT_URI}/ballot`;
      break;
  }
  return documentURL;
};

export const BallotStatus = [
  { key: "all", text: "All", value: "All" },
  { key: "open", text: "Open", value: "Open" },
  { key: "prepublish", text: "Prepublish", value: "Prepublish" },
  { key: "closed", text: "Closed", value: "Closed" },
];

export const BallotYearsOptions = [
  {
    id: new Date().getFullYear().toString(),
    value: new Date().getFullYear().toString(),
    label: new Date().getFullYear().toString(),
    siblingComponent: false,
    isDisabled: false,
  },
  {
    id: (new Date().getFullYear() + 1).toString(),
    value: (new Date().getFullYear() + 1).toString(),
    label: (new Date().getFullYear() + 1).toString(),
    siblingComponent: true,
    isDisabled: new Date().getMonth() < 9 ? true : false,
  },
];

export const AdvanceSearchFormType = {
  Ballot: "Ballot",
  Workitem: "Workitem"
};

export const BallotStatusType = {
  Closed: "Closed",
  Open: "Open",
  Prepublish: "Prepublish",
  Publish: "Published",
  PendingPublication:"Pending Publication"
};

export const BallotLevels = [
  { key: "6", text: "Society", value: "6" },
  { key: "1", text: "Main Committee", value: "1" },
  { key: "2", text: "Subcommittee", value: "2" },
  { key: "3", text: "Section", value: "3" }
];
export const AuditLogTypeEnum = {
  Add: 1,
  Edit: 2,
  Delete: 3,
  Recover: 4,
  InactiveCommittee: 5,
  InactiveTechnicalContact: 6,
  Suppressed: 7,
  PermanentDeleted: 8,
  collabEditApiFailed: 9,
  collabDeleteApiFailed: 10,
  collabRecoverApiFailed: 11,
  AddWITN: 12,
  EditWITN: 13,
  DeleteWITN: 14
}
export const WITNAuditLogTypeEnum = {
  Add: 1,
  Edit: 2,
  Delete: 3,
  ApprovalRescinded : 4
}
export const WIShowHideSuppressedOption = [
  { key: "1", text: "Show all", value: "1" },
  { key: "2", text: "Show only active", value: "2" },
  { key: "3", text: "Show only suppressed", value: "3" }
];


export const switchConfigs = [
    { name: 'TallyAllAdmin', id: 'custom-switch-1', label: 'Tally vote weight only' },
    { name: 'CommentRequired', id: 'custom-switch-2', label: 'Suppress comments' },
    { name: 'IsConcurrentItem', id: 'custom-switch-3', label: 'Concurrent item' },
  ];

export interface WorkItemListDataProps {
  CommitteeId?: string | number;
  CommitteeDesignation?: string;
  StandardDesignation?: string;
  WorkItemId?: number;
  WorkItemCategory?: string;
  WorkItemNumber?: string;
  WITN?: string;
  WorkItemTypeName?:string;
  Title?:string;
  WorkItemStatus?:string;
  IsSuppressed:number;
  IsDeleted:number;
  DraftCount:number;
  CreatedDate?:Date;
  FormattedStandardDesignation?: string;
  ModifiedDate?: Date;
}

export const VOTERLISTHEADERINFO = [
  {
    title: "Account",
    hasSorting: true,
    className: "",
    sortKey: "AccountNumber",
    orderBy: 0,
    sortType: "numeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: true,
  },
  {
    title: "Returned Status",
    hasSorting: true,
    className: "",
    sortKey: "ReturnedStatus",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Voting Status",
    hasSorting: true,
    className: "",
    sortKey: "VotingStatus",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Member Name",
    hasSorting: true,
    className: "",
    sortKey: "MemberName",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Email",
    hasSorting: true,
    className: "",
    sortKey: "MemberEmail",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "Balloted Committee",
    hasSorting: false,
    className: "",
    sortKey: "BallotedCommittee",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
  {
    title: "",
    hasSorting: false,
    className: "",
    sortKey: "VoteDetails",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
]

export const VOTING_SUMMARY_BALLOT_ITEMS_TABLE_HEADERS = [
  {
    title: "Item No.",
    hasSorting: false,
    className: "",
    sortKey: "ItemNumber",
    orderBy: 0,
    sortType: "alphanumeric",
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
    width: 250
  },
  {
    title: "",
    hasSorting: false,
    className: "",
    sortKey: "BallotItems",
    orderBy: 0,
    orderByIcon: 0,
    isShow: true,
    isDefaultSort: false,
  },
];

export const VOTE_OPTIONS = (i: number, data: any) => {
  const hideComments = data?.SuppressComment || data?.DraftActionId === DraftActionId.Uphold_Negative || data?.DraftActionId === DraftActionId.Confirmatory  || data?.DraftActionId === DraftActionId.Appeal_on_Cos;
  return hideComments
    ? [
        {
          id: "Affirmative" + i,
          label: VOTE_TYPE_DESCRIPTION.AFFIRMATIVE,
          value: VOTE_TYPE_ID.AFFIRMATIVE,
        },
        {
          id: "NegativeWithStatement" + i,
          label: VOTE_TYPE_DESCRIPTION.NEGATIVE,
          value: VOTE_TYPE_ID.NEGATIVE_WITH_STATEMENT,
        },
        {
          id: "Abstain" + i,
          label: VOTE_TYPE_DESCRIPTION.ABSTAIN,
          value: VOTE_TYPE_ID.ABSTAIN,
        },
      ]
    : [
        {
          id: "Affirmative" + i,
          label: VOTE_TYPE_DESCRIPTION.AFFIRMATIVE,
          value: VOTE_TYPE_ID.AFFIRMATIVE,
        },
        {
          id: "AffirmWithComment" + i,
          label: VOTE_TYPE_DESCRIPTION.AFFIRM_WITH_COMMENT,
          value: VOTE_TYPE_ID.AFFIRM_WITH_COMMENT,
        },
        {
          id: "NegativeWithStatement" + i,
          label: VOTE_TYPE_DESCRIPTION.NEGATIVE_WITH_STATEMENT,
          value: VOTE_TYPE_ID.NEGATIVE_WITH_STATEMENT,
        },
        {
          id: "Abstain" + i,
          label: VOTE_TYPE_DESCRIPTION.ABSTAIN,
          value: VOTE_TYPE_ID.ABSTAIN,
        },
        {
          id: "AbstainWithComment" + i,
          label: VOTE_TYPE_DESCRIPTION.ABSTAIN_WITH_COMMENT,
          value: VOTE_TYPE_ID.ABSTAIN_WITH_COMMENT,
        },
      ];
};

export const Returnoption = [
  { text: "All", value: "All", key: "All" },
  { text: "Returned", value: "Returned", key: "Returned" },
  { text: "Not Returned", value: "Not Returned", key: "Not Returned" },
];

export const VotingOption = [
  { text: "All", value: "All", key: "All" },
  { text: "Official", value: "Official", key: "Official" },
  { text: "Non Official", value: "Non Official", key: "Non Official" },
  { text: "Non Member", value: "Non Member", key: "Non Member" },
  { text: "Society", value: "Society", key: "Society" },
];

export const VoterListQuickFilters = {
  ReturnedStatus: "ReturnedStatus",
  VotingStatus: "VotingStatus",
  AccountNumber: "AccountNumber",
  BallotedCommittee: "BallotedCommittee",
};

export const SOCIETY_VOTER = "Society"

export interface VoterListDataProps {
  AccountNumber:number,
  ReturnedStatus:string,
  VotingStatus:string,
  MemberName:string,
  MemberEmail:string,
  BallotedCommittee:string
}
export const BSR108UploadOption = [
  {
    label: "Upload a new file",
    value: 1,
    id: "UploadAnewFile",
  },
  {
    label: "Upload a new version of an existing file",
    value: 2,
    id: "UploadAnewVersionOfanExistingFile",
  }
]

export const BallotRemoveForZnumberOption =[
  {
    label: "Retain the assigned standard designation associated with the work item.",
    value: 1,
    id: "RetainAssigned",
    siblingComponent:true,
    toolTipMessage:"<strong>Retain</strong>: the assigned designation stays linked to this work item and its Z number."
  },
  {
    label: "Release the assigned standard designation for reassignment.",
    value: 2,
    id: "ReleaseAssigned",
     siblingComponent:true,
     toolTipMessage:"<strong>Release</strong>: the assigned designation is unlinked and becomes available for assignment to another new standard."
  },
]
export const BALLOTLEVELOPTIONS =[
    {
      label: COMMITTEE_LEVELS.MC,
      value: 2,
      id: "LevelMC",
    },
    {
      label:COMMITTEE_LEVELS.SC,
      value: 1,
      id: "LevelSC",
    },
  ]

   export const  ADMIN_WORK_ITEM_TYPES= [
      { label: "Admin (AD)", value: WI_TYPE.ADMIN , id: 1, },
      { label: "Appeal on COS (CA)", value: WI_TYPE.APPEAL_ON_COS, id: 2 }
    ];

export const EXTERNAL_APP_URL = {
  STDMAINT_APP_DETAIL: `${process.env.REACT_APP_stdmaint_URL}/standard-management/designationDetail/`,
};

export const RULING_OPTIONS = {
  FAIL: 22,
  REMOVED_FOR_REBALLOT: 33,
  PERSUASIVE: 23,
  WITHDRAWN: 25,
  WITHDRAWN_WITH_EDITORIAL_CHANGES: 29,
  NOT_PERSUASIVE: 24,
  NOT_RELATED: 27,
  UNRESOLVED: 26,
  REMOVED: 31,
};

export const NEGATIVE_RULING_OPTIONS = [
  {
    title: 'Fail',
    label: 'Item Removed',
    value: RULING_OPTIONS.FAIL,
  },
  {
    title: 'Removed for Reballot',
    label: 'Item Removed',
    value: RULING_OPTIONS.REMOVED_FOR_REBALLOT,
  },
  {
    title: 'Persuasive',
    label: 'Persuasive',
    value: RULING_OPTIONS.PERSUASIVE,
  },
  {
    title: 'Withdrawn',
    label: 'Withdrawn',
    value: RULING_OPTIONS.WITHDRAWN,
  },
  {
    title: 'Withdrawn with Editorial Changes',
    label: 'Editorial Withdraw',
    value: RULING_OPTIONS.WITHDRAWN_WITH_EDITORIAL_CHANGES,
  },
  {
    title: 'Not Persuasive',
    label: 'Not Persuasive',
    value: RULING_OPTIONS.NOT_PERSUASIVE,
  },
  {
    title: 'Not Related',
    label: 'Not Related',
    value: RULING_OPTIONS.NOT_RELATED,
  },
  {
    title: 'Removed',
    label: 'Item Removed from Ballot',
    value: RULING_OPTIONS.REMOVED,
  },
];

export const MEMBERSHIP_TYPE = {
  STUDENT_MEMBER: 17,
};

export const NEGATIVE_MEMBER_VOTING_STATUS_TAGS = [
  "Non Member",
  "Society",
];

export const VoteWeightTitleType = {
  MAIN_SECTION: "Vote Weight (Main/Section)",
  MAIN_SUB: "Vote Weight (Main/Sub)",
  SECTION: "Vote Weight (Section)",
  SUB: "Vote Weight (Sub)",
  MAIN: "Vote Weight (Main)",
  DEFAULT: "Vote Weight",
}

export const BSR108ExpectedHeaders = [
            'Designation of Proposed Standard',
            'Title of Standard',
            'Project Intent',
            'Affected or Superseded Standard Designation',
            'ISO or IEC text included',
            'Scope Summary or Abstract of Project',
            'Price for Draft',
            'PR Length',
            'Acronym of ASD',
            'Send Comments to',
            'Order From',
            'URL 45-day PR Draft',
            'Consumer (Mark “x”)',
            'Solicit New Consensus Body Members (Mark “x”)',
            'Name of Submitter',
            'Committee Title',
            'Ballot',
            'PR Submit'
      ];
      
export const BSR109ExpectedHeaders: string[] = [
  "*Developer Acronym",
  "*Designation of Approved ANS",
  "Year Date Designation",
  "*Title of Standard",
  "*Project Intent",
  "Supersedes or Affects",
  "*Approval Date of an ANS",
  "*Submitter Name",
  "*Phone",
  "*Email",
  "*START PR Date",
  "# of Ballot items",
  "Pending Ballot Items"
];